/**
 * @file store 初始化
 */

import Vue from 'vue';
import Vuex from 'vuex';
import distribution from './modules/distribution';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        distribution,
    },
});
